const PREFIX = '@@KANDY/'

export const CONFIG_UPDATE = PREFIX + 'CONFIG_UPDATE'

export const SET_SDP_HANDLERS = PREFIX + 'SET_SDP_HANDLERS'
